import config from "../config"
const baseUrl = config.base_url + "z_farm_work_purpose/"
export default {
    listAll: {
        url: baseUrl + "listAll",
        type: "get",
    },
}